/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Free_ListingInputs */

const en_free_listing = /** @type {(inputs: Free_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Listing`)
};

const id_free_listing = /** @type {(inputs: Free_ListingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Gratis`)
};

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const es_free_listing = en_free_listing;

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const fr_free_listing = en_free_listing;

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const de_free_listing = en_free_listing;

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const ja_free_listing = en_free_listing;

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const zh_free_listing = en_free_listing;

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const ar_free_listing = en_free_listing;

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const it_free_listing = en_free_listing;

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const ru_free_listing = en_free_listing;

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const pt_free_listing = en_free_listing;

/** @type {(inputs: Free_ListingInputs) => LocalizedString} */
const ko_free_listing = en_free_listing;

/**
* | output |
* | --- |
* | "Free Listing" |
*
* @param {Free_ListingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const free_listing = /** @type {((inputs?: Free_ListingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Free_ListingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_free_listing(inputs)
	if (locale === "es") return es_free_listing(inputs)
	if (locale === "fr") return fr_free_listing(inputs)
	if (locale === "de") return de_free_listing(inputs)
	if (locale === "ja") return ja_free_listing(inputs)
	if (locale === "zh") return zh_free_listing(inputs)
	if (locale === "ar") return ar_free_listing(inputs)
	if (locale === "id") return id_free_listing(inputs)
	if (locale === "it") return it_free_listing(inputs)
	if (locale === "ru") return ru_free_listing(inputs)
	if (locale === "pt") return pt_free_listing(inputs)
	return ko_free_listing(inputs)
});